module.exports = __webpack_public_path__ + "assets/img/06c1b982b4a6faa9654aa6e84e097176.svg";